<template>
	<div id="app" class="app">
		<span class="app__bg">
			<img src="@/assets/images/bg.png" alt=""/>
		</span>
		<Icons/>
		<router-view/>
		<div class="videooverlay">
			<div class="videooverlay__box">
				<span class="videooverlay__close" @click="hideVideo"></span>
				<video v-if="startVideo" class="videooverlay__box__video" autoplay loop ref="videoPlayer">
					<source src="../public/images/dietro-le-quinte.mp4" type="video/mp4">
				</video>
			</div>
		</div>
	</div>
</template>

<script>
import {EventBus} from '@/events_bus.js';

import Icons from '@/views/layouts/utils/Icons';

export default {
	name: 'App',
	components: {
		Icons,
	},
	data() {
		return {
			windowWidth: 0,
			startVideo: false,
		}
	},

	methods: {
		checkParams() {
			let params = window.location.search;
			let value = new URLSearchParams(params);
		},
		onResize() {
			let mode = localStorage.getItem('mode');
			this.windowWidth = window.innerWidth;
			if (this.windowWidth < 1200) {
				localStorage.setItem('mode', 'mobile');
				if (mode != 'mobile') {
					window.location.reload();
				}
			} else {
				localStorage.setItem('mode', 'desktop');
				if (mode != 'desktop') {
					window.location.reload();
				}
			}
		},
		init() {
			// this.$api.refreshToken().then(res => {
			// 	console.log('Refresh Token');
			// }).catch(err => {
			// 	console.error('ERR', err);
			// 	if(localStorage.getItem('tokentimer')) {
			// 		this.$router.push({ name: 'login.page' })
			// 	}
			// })
		},
		hideVideo() {
			console.log('hide video');
			this.startVideo = false;
			document.querySelector('.videooverlay').classList.remove('show');
		}
	},
	mounted() {
		this.init();
		this.onResize();
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.onResize();
			});
		});
		this.checkParams();

		EventBus.$on('showvideo', () => {
			console.log('show video');
			this.startVideo = true;
			document.querySelector('.videooverlay').classList.add('show');
		});
	}
}
</script>

<style lang="scss">
.app__bg {
	position: absolute;
	top: 0;
	left: 0;
	display: block;
	width: 100%;

	img {
		display: block;
		width: 100%;
		mix-blend-mode: lighten;
	}
}

.videooverlay {
	position: fixed;
	top: 0;
	left: 0;
	@extend %flexCenterCenter;
	background: rgba(#000, 0.7);
	@include size(100%,100%);
	overflow: hidden;
	z-index: 1000000;
	opacity: 0;
	pointer-events: none;
	transition: 180ms linear;
	&__box {
		display: block;
		background: #fff;
		width: 96%;
		aspect-ratio: 9 / 16;
		position: relative;
		border-radius: 8px;
		overflow: hidden;
		transform: translateY(140%);
		transition: 360ms linear;
		video {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
			position: relative;
			z-index: 4;
		}
	}
	&__close {
		position: absolute;
		top: 15px;
		right: 15px;
		display: block;
		background: #fff;
		@include size(30px,30px);
		border-radius: 100%;
		@extend %arrowClose;
		z-index: 10;
		pointer-events: all;
		&:before,
		&:after {
			background: #000;
			@include size(50%,2px);
			pointer-events: none;
		}
	}
	&.show {
		opacity: 1;
		pointer-events: all;
		.videooverlay__box {
			transform: translateY(0);
		}
	}
}
</style>
